import { Route, Routes } from 'react-router-dom';
import CouponPage from '../pages/Promotion/CouponPage';
import HanwaPromotion from '../pages/Promotion/HanwaPromotion';

export default function PromotionRoute() {
  return (
    <Routes>
      <Route path="/coupon" element={<CouponPage />} />
      <Route path="/easy-rest" element={<HanwaPromotion />} />
    </Routes>
  );
}
